import { AfterViewInit, Directive, ElementRef } from '@angular/core';
import { ReconcileHtmlLinkService } from './reconcile-html-link.service';

/**
 * ReconcileHtmlLinkDirective provides us with a way to bind html links to use angular routing when
 * it is not possible to do so by default * i.e. links processed by InnerHTML directive
 */
@Directive({ selector: '[reconcileHtmlLink]' })
export class ReconcileHtmlLinkDirective implements AfterViewInit {
  anchors: HTMLAnchorElement[];

  constructor(
    private reconcileHtmlLinkService: ReconcileHtmlLinkService,
    private elementRef: ElementRef,
  ) {}

  ngAfterViewInit() {
    this.anchors = this.elementRef.nativeElement.querySelectorAll('a');
    this.anchors.forEach((anchor: HTMLAnchorElement) => {
      this.reconcileHtmlLinkService.addClickEventListenerForInternalRoutes(
        anchor,
      );
    });
  }
}
